export enum ContractStatusEnum {
    ACTIVE = "pt.edp.edponline.state.ACTIVO",
    IN_ACTIVATION = "pt.edp.edponline.state.EMACTIVACAO",
    INACTIVE = "pt.edp.edponline.state.INACTIVO",
    WAITFORSUBSCRIPTION = "pt.edp.edponline.state.AGUARDARASSINATURA",
}
